import React from "react";

import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";

import BatchDetail from "../../../common/BatchDetail";
import useAxios from "../../../../hooks/useAxios";
import useAlert from "../../../../hooks/useAlert";
import { pauseColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getPause, __pauseSelectelRecheck } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "trial_count",
  "last_updated",
];

const RecheckButton = ({ batch_id }) => {
  const { setAlertMessage } = useAlert();
  const [recheckResponse, recheckCall, recheckLoading] = useAxios({
    ...__pauseSelectelRecheck,
  });

  React.useEffect(() => {
    if (recheckResponse && recheckResponse.status) {
      setAlertMessage({
        type: "success",
        message: "Pause recheck queued",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recheckResponse]);

  return (
    <Grid item sx={{ mb: "10px" }}>
      <Button
        variant="contained"
        color="primary"
        disabled={recheckLoading}
        onClick={() => recheckCall({ params: { batch_id: batch_id } })}
      >
        Recheck Status
      </Button>
    </Grid>
  );
};

const SelectelPauseBatch = () => (
  <BatchDetail
    title="Pause"
    apiGet={__getPause}
    client={CLIENTS.selectel}
    columnsFactory={pauseColumns}
    copyKeys={COPY_KEYS}
    exportAction="pause"
    retryOperation="pause"
    showTerminate
    getRowPath={(row) => `/selectel/pause/${row.id}`}
    extraActions={({ batch_id }) => <RecheckButton batch_id={batch_id} />}
  />
);

export default SelectelPauseBatch;
